// extracted by mini-css-extract-plugin
module.exports = {"wrapperMain":"UserList_wrapperMain__39KGG","wrapperInner":"UserList_wrapperInner__2_IXo","wrapperDivider":"UserList_wrapperDivider__RXoTz","p":"UserList_p__3qgn0"};